import type { AssetsSelectParentOptionItemData } from "../assets-select-parent.type";

import { formatPathFromAncestors } from "@/entities/ancestor";

export const getAssetsSelectParentOptionItem = (
  asset: AssetsSelectParentOptionItemData
) => {
  const { id, ancestors } = asset;
  return {
    value: id,
    label: formatPathFromAncestors(ancestors, {
      shouldTruncate: false,
      includeTypes: ["asset"],
    }),
    truncatedLabel: formatPathFromAncestors(ancestors, {
      shouldTruncate: true,
      includeTypes: ["asset"],
    }),
  };
};
